import { useState, useEffect } from "react";

export function useLocalDraft(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(`draft_${key}`);
      return saved ? JSON.parse(saved) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(`draft_${key}`, JSON.stringify(value));
    } catch {}
  }, [key, value]);

  function clearDraft() {
    try {
      localStorage.removeItem(`draft_${key}`);
    } catch {}
    setValue(initialValue);
  }

  return [value, setValue, clearDraft];
}